(() => {
  'use strict';

  const finePointer = window.matchMedia('(pointer: fine) and (min-width: 900px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!finePointer.matches || reducedMotion.matches) return;

  let currentY = window.scrollY;
  let targetY = currentY;
  let frame = 0;
  let wheelAnimating = false;
  let anchorAnimating = false;

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const maxScroll = () => Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

  function normalizeWheelDelta(event) {
    if (event.deltaMode === 1) return event.deltaY * 16;
    if (event.deltaMode === 2) return event.deltaY * window.innerHeight;
    return event.deltaY;
  }

  function shapeWheelDelta(delta) {
    const sign = Math.sign(delta);
    const magnitude = Math.min(Math.abs(delta), 180);
    // Compress large wheel notches / trackpad flicks so the page gains momentum
    // instead of jumping almost one viewport in a single input event.
    return sign * Math.pow(magnitude, 0.88) * 0.72;
  }

  function nestedScrollerCanMove(target, deltaY) {
    let node = target instanceof Element ? target : null;
    while (node && node !== document.body && node !== document.documentElement) {
      const style = getComputedStyle(node);
      const overflowY = style.overflowY;
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight + 1) {
        if (deltaY < 0 && node.scrollTop > 0) return true;
        if (deltaY > 0 && node.scrollTop + node.clientHeight < node.scrollHeight - 1) return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function stopAnimation(sync = true) {
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    wheelAnimating = false;
    anchorAnimating = false;
    if (sync) currentY = targetY = window.scrollY;
  }

  function wheelStep() {
    const distance = targetY - currentY;
    // Deliberately lower than ordinary smooth-scroll scripts. This creates the
    // weighted / inertial feel: input moves the destination, not the page directly.
    currentY += distance * 0.09;
    window.scrollTo(0, currentY);

    if (Math.abs(distance) <= 0.28) {
      currentY = targetY;
      window.scrollTo(0, currentY);
      frame = 0;
      wheelAnimating = false;
      return;
    }

    frame = requestAnimationFrame(wheelStep);
  }

  window.addEventListener('wheel', (event) => {
    if (event.ctrlKey || event.metaKey || anchorAnimating) return;

    const rawDelta = normalizeWheelDelta(event);
    if (!rawDelta || nestedScrollerCanMove(event.target, rawDelta)) return;

    event.preventDefault();
    if (!wheelAnimating) currentY = targetY = window.scrollY;

    const shaped = shapeWheelDelta(rawDelta);
    const proposed = targetY + shaped;
    // Even if the wheel is spun very quickly, do not let the virtual target get
    // absurdly far ahead of the rendered page. It feels smooth instead of detached.
    targetY = clamp(proposed, Math.max(0, currentY - 900), Math.min(maxScroll(), currentY + 900));
    wheelAnimating = true;
    if (!frame) frame = requestAnimationFrame(wheelStep);
  }, { passive: false });

  window.addEventListener('scroll', () => {
    if (!wheelAnimating && !anchorAnimating) currentY = targetY = window.scrollY;
  }, { passive: true });

  window.addEventListener('resize', () => {
    stopAnimation(false);
    currentY = window.scrollY;
    targetY = clamp(currentY, 0, maxScroll());
  }, { passive: true });

  // Keyboard remains native/instant-accessible. A keyboard action cancels any
  // leftover wheel momentum rather than fighting the browser's own navigation.
  window.addEventListener('keydown', () => stopAnimation(true), true);
  window.addEventListener('mousedown', () => {
    if (anchorAnimating) stopAnimation(true);
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href === '#') return;

    let destination;
    try { destination = document.querySelector(href); } catch (_) { return; }
    if (!destination) return;

    event.preventDefault();
    stopAnimation(false);

    const header = document.querySelector('.site-header');
    const headerOffset = header ? header.getBoundingClientRect().height + 12 : 0;
    const startY = window.scrollY;
    const endY = clamp(startY + destination.getBoundingClientRect().top - headerOffset, 0, maxScroll());
    const distance = Math.abs(endY - startY);
    const duration = clamp(560 + distance * 0.10, 680, 1050);
    const startedAt = performance.now();

    anchorAnimating = true;
    currentY = startY;
    targetY = endY;

    const anchorStep = (now) => {
      const progress = clamp((now - startedAt) / duration, 0, 1);
      const eased = 1 - Math.pow(1 - progress, 5);
      currentY = startY + (endY - startY) * eased;
      window.scrollTo(0, currentY);

      if (progress < 1) {
        frame = requestAnimationFrame(anchorStep);
      } else {
        currentY = targetY = endY;
        frame = 0;
        anchorAnimating = false;
        if (history.replaceState) history.replaceState(null, '', href);
      }
    };

    frame = requestAnimationFrame(anchorStep);
  });
})();
